import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["achCaption", "amount", "checkNumber", "method"]

  connect() {
    this.change()
  }

  change() {
    const selected = this.methodTargets.find((method) => method.checked)
    if (!selected) return

    const max = Number(selected.dataset.max)
    const amount = Number(this.amountTarget.value)
    const previousMax = Number(this.amountTarget.max)
    this.amountTarget.max = max.toFixed(2)
    if (!this.amountTarget.value || amount > max || amount === previousMax) {
      this.amountTarget.value = max.toFixed(2)
    }

    this.achCaptionTargets.forEach((caption) => {
      caption.classList.toggle("hidden", selected.dataset.electronic !== "true")
      caption.parentElement.classList.toggle("hidden", selected.dataset.electronic !== "true")
    })

    this.checkNumberTargets.forEach((field) => {
      field.classList.toggle("hidden", selected.dataset.check !== "true")
      field.querySelectorAll("input").forEach((input) => {
        input.disabled = selected.dataset.check !== "true"
      })
    })
  }
}
